import { CONFIG } from "../config"
import {
  APIService,
  isShowWidgetData,
  type HideWidgetData,
  type ShowWidgetData,
} from "../services/api"

import { CallToAction } from "./CallToAction"
import { Modal } from "./Modal"
import { PoweredBy } from "./PoweredBy"

export class Widget {
  private root: HTMLElement
  private container: HTMLElement
  private modal: Modal | null = null

  constructor(root: HTMLElement) {
    this.root = root
    this.container = document.createElement("div")
    this.container.className = CONFIG.WIDGET_WRAPPER_CLASS

    this.container.addEventListener("click", () => {
      this.modal?.open()
    })
  }

  async initialize(): Promise<void> {
    const apiKey = this.root.dataset.tfgApiKey
    if (!apiKey) {
      console.warn(
        "TFG API Key is missing. Please add a data-tfg-api-key attribute to your widget container."
      )
      return
    }

    const productCode = this.root.dataset.tfgProductCode
    if (!productCode) {
      console.warn(
        "TFG Product Code is missing. Please add a data-tfg-product-code attribute to your widget container."
      )
      return
    }

    let data: ShowWidgetData | HideWidgetData = { show: false }

    try {
      data = await APIService.fetchWidgetData(productCode, apiKey)
    } catch (e) {
      console.error("Error fetching TFG widget data")
      console.error(e)
    }

    if (isShowWidgetData(data)) {
      this.modal = new Modal({ iframeSrc: data.sheetUrl })
      const callToAction = new CallToAction({
        config: this.root.dataset,
      }).render()
      const poweredBy = new PoweredBy({ config: this.root.dataset }).render()
      this.container.appendChild(callToAction)
      this.container.appendChild(poweredBy)
      this.root.appendChild(this.container)
    }
  }
}
